import { NgModule } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from './services/notification.service';

@NgModule({
    providers: [
        NotificationService,
        ToastrService,
    ]
})
export class NotificationModule {}